<template>
  <div>
    <div class="chore-cell-container">
      <div class="chore-cell-top-subcontainer">
        <div class="chore-cell-group-1">
          <img
            class="chore-cell-user-icon"
            alt="User Icon"
            src="@/assets/lightGreyUserIcon.svg"
          />
          <div class="chore-cell-housemate-name">
            Room {{ assignment.housemate.roomName }} -
            {{ assignment.housemate.name }}
          </div>
        </div>
        <div v-if="!readOnly" class="chore-cell-group-2">
          <img
            class="chore-cell-edit-icon"
            src="@/assets/darkGreenPencil.svg"
            alt="Edit Icon"
            @click="editAssignment"
          />
        </div>
      </div>

      <div class="chore-cell-bottom-subcontainer">
        <img
          class="chore-cell-calendar-icon"
          src="@/assets/lightGreyCalendar.svg"
          alt="Calendar Icon"
        />
        <div class="chore-cell-assignment-date">{{ convertDate() }}</div>
        <img
          v-if="!readOnly"
          class="chore-cell-delete-icon"
          alt="Delete Icon"
          src="@/assets/rentalButtonIcons/greyDelete.svg"
          @click="selDeleteAssignment = true"
        />
      </div>
    </div>
    <delete-popup
      v-if="selDeleteAssignment"
      @confirm="deleteAssignment()"
      @cancel="selDeleteAssignment = false"
      :thingName="'chore schedule'"
    />
  </div>
</template>

<script>
import DeletePopup from '../../components/GenericDeletePopup.vue'
// import calls from "@/api/calls"
export default {
  name: 'ChoreCellhousemate',
  data() {
    return {
      selDeleteAssignment: false,
      room: ''
    }
  },
  components: {
    DeletePopup
  },
  props: {
    assignment: Object,
    readOnly: Boolean
  },
  methods: {
    editAssignment() {
      this.$emit('edit-assignment', this.assignment)
    },
    deleteAssignment() {
      this.$emit('delete-assignment', this.assignment)
    },
    getDate: function () {
      var d = new Date()

      var date = d.getDate()
      var month = d.getMonth() + 1 // Since getMonth() returns month from 0-11 not 1-12
      var year = d.getFullYear()

      return date + '/' + month + '/' + year
    },
    convertDate() {
      var d = new Date(this.assignment.date)
      d.setMinutes(d.getMinutes() + d.getTimezoneOffset())
      var minutes = d.getMinutes()
      if (minutes < 10) minutes = `0${minutes}`

      //`${d.toDateString()} ${d.getHours().toString()}:${minutes}`
      return `${d.toDateString()}`
    }
    // Modified to return room name on chores call to avoid making more requests
    // async getAllRoomsFromProperty(){
    //   const {error, message, data} = await calls.GET('properties/rooms', this.assignment.chore.propertyId);
    //   if(error) console.log(message)
    //   for (let datum of data){
    //     this.getRentalsFromRoom(datum.uuid);
    //   }
    // },

    // async getRentalsFromRoom(roomId){
    //   const {message, data} = await calls.GET('rental/housemates', roomId);
    //     if (message) throw Error(message)
    //     for (let datum of data){
    //       if(datum[1].uuid === this.assignment.housemate.uuid){
    //         this.room = datum[2].internalName
    //       }
    //     }
    // },
  },
  async beforeMount() {
    // await this.getAllRoomsFromProperty();
  }
}
</script>

<style scoped>
img.chore-cell-user-icon {
  min-width: 18px;
  min-height: 18px;
}
img.chore-cell-calendar-icon {
  min-width: 18px;
  min-height: 18px;
  padding-left: 2px;
}

img.chore-cell-delete-icon {
  min-width: 16px;
  min-height: 16px;
  cursor: pointer;
}

img.chore-cell-edit-icon {
  min-width: 16px;
  min-height: 16px;
  padding-left: 2px;
  padding-right: 2px;
  cursor: pointer;
  margin-left: 8px;
}

.chore-cell-container {
  background: rgba(231, 231, 231, 0.2);
  border: 0.5px solid #e7e7e7;
  box-sizing: border-box;
  border-radius: 4px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  padding: 14px;

  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #767675;
  margin-bottom: 10px;
}

.chore-cell-group-1,
.chore-cell-group-2 {
  display: flex;
  flex-flow: row nowrap;
  padding: 8px 0;
}

.chore-cell-group-1 {
  flex-grow: 2;
}
.chore-cell-group-1 div {
  flex-grow: 2;
  text-align: left;
  padding-left: 10px;
}

.chore-cell-top-subcontainer {
  display: flex;
  flex-flow: row nowrap;
  padding-bottom: 10px;
}

.chore-cell-bottom-subcontainer {
  display: flex;
  flex-flow: row nowrap;
}
.chore-cell-bottom-subcontainer div {
  flex-grow: 2;
  text-align: left;
  padding-left: 10px;
}

.chore-cell-group-2 {
  flex-direction: column;
  align-items: baseline;
}
</style>
